import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FormikProvider, useFormik, FieldArray, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaPlusCircle, FaTrash } from "react-icons/fa";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import Select from "react-select";
import { config } from "../CommonUtils/CommonURLS";
export default function MergeOfInstApplicationDetails() {
    const [getMergeData, setMergeData] = useState([])
    const tableWrapperRef = useRef(null);
    const initialValues = {
        childInstitutionName: "",
        childInstitutionCode: "",
        parentInstitutionName: "",
        parentInstitutionCode: "",
        courses: [
            { course: "", year1: 0, year2: 0, year3: 0 }
        ]
    };
    const validationSchema = Yup.object({
        // parentInstitutionName: Yup.string()
        //     .required("Parent Institution is required"),

        childInstitutionName: Yup.string()
            .required("Child Institution is required")
            .test(
                "not-same",
                "Child and Parent Institutions cannot be same",
                function (value) {
                    const parentCode = this.resolve(Yup.ref("parentInstitutionCode")); // NOSONAR
                    if (!value || !parentCode) return true;
                    return value !== parentCode;
                }
            ),
        // parentInstitutionName: Yup.string().required("Parent Institution Name is required"),
        courses: Yup.array().of(
            Yup.object({
                course: Yup.string().required("Course is required"),
                year1: Yup.number().typeError("Must be a number").min(0, "Invalid number"),
                year2: Yup.number().typeError("Must be a number").min(0, "Invalid number"),
                year3: Yup.number().typeError("Must be a number").min(0, "Invalid number")
            })
        )
    });
    const username = sessionStorage.getItem("user_name");
    const userId = sessionStorage.getItem("user_id");
    function getMergeApplicationDetails() {
        let url = "/api/merge-application-details";
        CommonAxiosGet(url)
            .then((res) => {
                if (res !== null && res.data) {
                    setMergeData(res.data.data || []);
                    if (res.data.data && res.data.data.length > 0) {

                        const applicationData = res.data.data[0];
                        formik.setValues({
                            childInstitutionName: applicationData.childInstitutionName || "",
                            childInstitutionCode: applicationData.childInstitutionCode || "",
                            parentInstitutionName: applicationData.parentInstitutionName || "",
                            parentInstitutionCode: applicationData.parentInstitutionCode || "",
                            courses: applicationData.courses || [{ course: "", year1: 0, year2: 0, year3: 0 }]
                        });
                    } else {
                        setMergeData([]);
                    }
                } else {
                    setMergeData([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching merge application details:", error);
                setMergeData([]);
            });
    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (values, { resetForm }) => {
            handleSubmit(values, resetForm);
        }
    });
    const yearFields = ["year1", "year2", "year3"];

    useEffect(() => {
        getMergeApplicationDetails();
        getInstitutionData();
        GetCourseDetails();
    }, [])
    useEffect(() => {
        formik.setFieldValue("parentInstitutionName", username);
        formik.setFieldValue("parentInstitutionCode", userId);
    }, []);
    const handleSubmit = (values, resetForm) => {
        // Show confirmation dialog
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to submit this merger application?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#1d2b3a',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, submit it!'
        }).then((result) => {
            if (result.isConfirmed) {
                // Show loading
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Application submitted successfully',
                    confirmButtonColor: '#1d2b3a'
                }).then(() => {
                    window.location.reload();
                });
                // Prepare data for submission
                const submitData = {
                    childInstitutionName: values.childInstitutionName,
                    childInstitutionCode: values.childInstitutionCode,
                    parentInstitutionName: values.parentInstitutionName,
                    parentInstitutionCode: values.parentInstitutionCode,
                    courses: values.courses.map(course => ({
                        course: course.course,
                        year1: Number(course.year1),
                        year2: Number(course.year2),
                        year3: Number(course.year3)
                    })),
                    submittedDate: new Date().toISOString()
                };
                let url = "/api/merge-application-submit";

                CommonAxiosPost(url, submitData)
                    .then((res) => {
                        if (res !== null && res.data) {
                            // Success
                            Swal.fire({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Application submitted successfully',
                                confirmButtonColor: '#1d2b3a'
                            });

                            // Reset form after successful submission
                            resetForm();

                            // Refresh the data
                            getMergeApplicationDetails();
                        } else {
                            // Error
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: 'Failed to submit application',
                                confirmButtonColor: '#1d2b3a'
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Submit Error:", error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: error.message || 'Failed to submit application',
                            confirmButtonColor: '#1d2b3a'
                        });
                    });
            }
        });
    };
    const [getInstData, setInstData] = useState([])
    function getInstitutionData() {
        let url = config.url.FAC_URL + "getInstdtls"
        CommonAxiosGet(url).then((res) => {
            if (res !== null) {
                if (res.data.status === true) {
                    setInstData(res.data.data)
                }
                else {
                    setInstData([])
                }
            }
        })
    }
    const instOptions = getInstData.map((item) => ({

        value: item.coll_code,
        label: item.inst_name
    }));
    const [courseData, setCourseData] = useState([]);
    function GetCourseDetails() {
        const url = `${config.url.FAC_URL}getCourseIntakeList`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.status === true && res?.data?.list?.length > 0) {
                    setCourseData(res.data.list);
                } else {
                    setCourseData([]);
                }
            })
            .catch((err) => {
                console.error("API Fetch Error:", err);
            });
    }
    const courseOptions = courseData.map((item) => ({
        value: item.course_id,
        label: item.course_name
    }));
    return (
        <Container fluid className="mt-3">
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>

                    {/* Header */}
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            {/* <div className="p-3 mb-3 text-white rounded" style={{ background: "linear-gradient(90deg,#1d2b3a,#0d3a59)" }}>
                               
                            </div> */}
                            <h5 className="mb-3 innerheader-new"><span> 🤝 <b>Merger of Institutions</b></span></h5>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            <Form.Label>Parent Institution Name <span style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control
                                name="parentInstitutionName"
                                value={username}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                disabled
                            />

                            <ErrorMessage name="parentInstitutionName" component="div" className="text-danger" />
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            <Form.Label>Parent Institution Code</Form.Label>
                            <Form.Control
                                name="parentInstitutionCode"
                                // value={formik.values.parentInstitutionCode}
                                value={userId}
                                onChange={formik.handleChange}
                                disabled
                            />


                        </Col>
                    </Row>
                    {/* Institution Details */}
                    <Row className="mb-3">
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            <Form.Label>Child Institution Name <span style={{ color: "red" }}>*</span></Form.Label>
                            {/* <Form.Control
                                name="childInstitutionName"
                                value={formik.values.childInstitutionName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            /> */}
                            <Select
                                options={instOptions}
                                placeholder="Search Institution"
                                // isDisabled={isSubmitted}
                                value={instOptions.find(
                                    (option) => option.value === formik.values.childInstitutionName
                                )}
                                onChange={(selectedOption) => {

                                    const selectedCode = selectedOption.value;


                                    formik.setFieldValue("childInstitutionName", selectedCode);
                                    formik.setFieldValue("childInstitutionCode", selectedCode);
                                    formik.setFieldTouched("childInstitutionName", true);

                                }}
                            />
                            <ErrorMessage name="childInstitutionName" component="div" className="text-danger" />
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            <Form.Label>Child Institution Code</Form.Label>
                            <Form.Control
                                name="childInstitutionCode"
                                value={formik.values.childInstitutionCode}
                                onChange={formik.handleChange}
                                disabled
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            <Form.Label>
                                Merger of Institutions under the same/ different Trust/ Society/ Company operating in the same Campus or City
                            </Form.Label>
                            <Form.Select
                                name="merge_dif"
                                value={formik.values.merge_dif}
                                onChange={formik.handleChange}
                            >
                                <option value="">Select </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Form.Select>
                        </Col>
                    </Row>


                    {/* Courses Table */}
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <h5 className="mt-4">Students to be Re-allotted (Branch & Year Wise)</h5>
                        </Col>
                    </Row>

                    <Row>
                        {/* <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <FieldArray name="courses">
                                {arrayHelpers => (
                                    <div className="table-responsive" ref={tableWrapperRef}>
                                        <table className="table table-bordered table-hover">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{ width: "5%" }}>S.No</th>
                                                    <th style={{ width: "25%" }}>Course / Branch</th>
                                                    {yearFields.map((year, idx) => (
                                                        <th key={idx} style={{ width: "15%" }}>{year.replace("year", "")}st Year</th>
                                                    ))}
                                                    <th style={{ width: "10%" }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formik.values.courses.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="align-middle">{index + 1}</td>

                                                        <td>
                                                            <Field
                                                                name={`courses.${index}.course`}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter course name"
                                                            />
                                                            <ErrorMessage
                                                                name={`courses.${index}.course`}
                                                                component="div"
                                                                className="text-danger small"
                                                            />
                                                        </td>

                                                        {yearFields.map((year, yIdx) => (
                                                            <td key={yIdx}>
                                                                <Field
                                                                    name={`courses.${index}.${year}`}
                                                                    type="number"
                                                                    className="form-control form-control-sm text-end"
                                                                    placeholder="0"
                                                                />
                                                                <ErrorMessage
                                                                    name={`courses.${index}.${year}`}
                                                                    component="div"
                                                                    className="text-danger small"
                                                                />
                                                            </td>
                                                        ))}

                                                        <td className="text-center align-middle">
                                                            
                                                            {formik.values.courses.length > 1 && (
                                                                <FaTrash
                                                                    style={{ color: "red", cursor: "pointer", fontSize: "18px", marginRight: "8px" }}
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                    title="Delete row"
                                                                />
                                                            )}

                                                            {index === formik.values.courses.length - 1 && (
                                                                <Button
                                                                    size="sm"
                                                                    variant="success"
                                                                    onClick={() => {
                                                                        arrayHelpers.push({ course: '', year1: 0, year2: 0, year3: 0 });
                                                                        setTimeout(() => {
                                                                            if (tableWrapperRef.current) {
                                                                                tableWrapperRef.current.scrollTop = tableWrapperRef.current.scrollHeight;
                                                                            }
                                                                        }, 100);
                                                                    }}
                                                                    title="Add new row"
                                                                >
                                                                    +
                                                                </Button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                            
                                        </table>
                                    </div>
                                )}
                            </FieldArray>
                        </Col> */}
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <FieldArray name="courses">
                                {arrayHelpers => (
                                    <div className="table-responsive" ref={tableWrapperRef}>
                                        <table className="table table-bordered table-hover">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{ width: "5%" }}>S.No</th>
                                                    <th style={{ width: "25%" }}>Course / Branch</th>
                                                    {yearFields.map((year, idx) => (
                                                        <th key={idx} style={{ width: "15%" }}>{year.replace("year", "")}st Year</th>
                                                    ))}
                                                    <th style={{ width: "10%" }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formik.values.courses.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="align-middle">{index + 1}</td>


                                                        {/* <Field
                                                                name={`courses.${index}.course`}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter course name"
                                                            /> */}
                                                        {/* <Select
                                                                options={courseOptions}
                                                                placeholder="Select Course"
                                                                value={courseOptions.find(
                                                                    (option) => option.value === formik.values.courses[index].course
                                                                )}
                                                                onChange={(selectedOption) => {
                                                                    formik.setFieldValue(`courses.${index}.course`, selectedOption.value);
                                                                }}
                                                            /> */}
                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`courses.${index}.course`}
                                                                className="form-select form-select-sm"
                                                            >
                                                                <option value="">Select Course</option>

                                                                {courseData.map((item) => (
                                                                    <option key={item.course_code} value={item.course_code}>
                                                                        {item.course_name}
                                                                    </option>
                                                                ))}
                                                            </Field>

                                                            <ErrorMessage
                                                                name={`courses.${index}.course`}
                                                                component="div"
                                                                className="text-danger small"
                                                            />
                                                        </td>

                                                        {/* <ErrorMessage
                                                                name={`courses.${index}.course`}
                                                                component="div"
                                                                className="text-danger small"
                                                            /> */}


                                                        {yearFields.map((year, yIdx) => (
                                                            <td key={yIdx}>
                                                                <Field
                                                                    name={`courses.${index}.${year}`}
                                                                    type="number"
                                                                    className="form-control form-control-sm text-end"
                                                                    placeholder="0"
                                                                    onInput={(e) => {
                                                                        if (e.target.value.length > 4) {
                                                                            e.target.value = e.target.value.slice(0, 4);
                                                                        }
                                                                    }}
                                                                />
                                                                <ErrorMessage
                                                                    name={`courses.${index}.${year}`}
                                                                    component="div"
                                                                    className="text-danger small"
                                                                />
                                                            </td>
                                                        ))}

                                                        <td className="text-center align-middle">
                                                            {/* Remove row */}
                                                            {formik.values.courses.length > 1 && (
                                                                <FaTrash
                                                                    style={{ color: "red", cursor: "pointer", fontSize: "18px", marginRight: "8px" }}
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                    title="Delete row"
                                                                />
                                                            )}

                                                            {/* Add row button only in the last row */}
                                                            {/* {index === formik.values.courses.length - 1 && (
                                                            <Button
                                                                size="sm"
                                                                variant="success"
                                                                onClick={() => {
                                                                    arrayHelpers.push({ course: '', year1: 0, year2: 0, year3: 0 });
                                                                    setTimeout(() => {
                                                                        if (tableWrapperRef.current) {
                                                                            tableWrapperRef.current.scrollTop = tableWrapperRef.current.scrollHeight;
                                                                        }
                                                                    }, 100);
                                                                }}
                                                                title="Add new row"
                                                            >
                                                                +
                                                            </Button>
                                                        )} */}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                            {/* Add the footer here */}
                                            <tfoot className="faculty-table-footer">
                                                <tr>
                                                    <td colSpan="9" className="text-end">
                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            onClick={() => {
                                                                // This push should be for a different array - maybe you have a separate faculty array?
                                                                // If you want to add to courses, use arrayHelpers.push instead
                                                                arrayHelpers.push({
                                                                    course: "",
                                                                    year1: 0,
                                                                    year2: 0,
                                                                    year3: 0
                                                                });
                                                            }}
                                                        >
                                                            <FaPlusCircle className="me-2" />
                                                            Add
                                                        </Button>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                            </FieldArray>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-end">
                            <Button className="btn-primary"
                                type="submit"
                                variant="primary"
                            // style={{ background: "#1d2b3a", border: "none", padding: "10px 30px" }}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </FormikProvider>
        </Container>
    );
}